import { render } from "./CaregiverDetailView.vue?vue&type=template&id=82cd2300&scoped=true"
import script from "./CaregiverDetailView.vue?vue&type=script&lang=js"
export * from "./CaregiverDetailView.vue?vue&type=script&lang=js"

import "./CaregiverDetailView.vue?vue&type=style&index=0&id=82cd2300&lang=css"
import "./CaregiverDetailView.vue?vue&type=style&index=1&id=82cd2300&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82cd2300"]])

export default __exports__